import _APP_CONFIG from "config/app";
import { Dimensions, StyleSheet } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { Box } from "native-base";
import MapView, { Marker } from "react-native-maps";
import AppStore from "AppStore";
import { getLatLong } from "AppActions";
import LoadingAnimation from "widgets/loading-animation";

const MitraMap = ({ route, navigation }: any) => {
  const [_, setCurrentPageInit] = AppStore("currentPageInit");
  const [latLong] = AppStore("latLong");
  const [markers, setMarkers] = useState<any>([]);
  const [initialCoords, setInitialCoords] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const mapRef: any = useRef(null);

  let locations: any = [];
  let data = route.params.data;

  useEffect(() => {
    getLatLong();
    if (data.length) {
      for (let i in data) {
        let latLong = data[i].lat_long;
        // let latLong = JSON.parse(data[i].lat_long);
        if (latLong && latLong.latitude !== null && latLong.longitude != null) {
          let lat = latLong.latitude;
          let long = latLong.longitude;
          let name = data[i].name;
          locations.push({ title: name, latitude: lat, longitude: long });
        }
      }
      setMarkers(locations);
      setIsLoading(false);
    }
  }, [route]);

  useEffect(() => {
    if (Object.keys(latLong).length) {
      let coords = { ...latLong };
      coords.latitudeDelta = 0.02;
      coords.longitudeDelta = 0.02;
      setInitialCoords(coords);
    }
  }, [latLong]);

  const reload = () => {
    navigation.goBack();
  };

  useEffect(() => {
    setCurrentPageInit(reload);
  }, []);

  const fitMarkers = () => {
    setTimeout(() => {
      if (mapRef && mapRef.current) {
        mapRef.current.fitToCoordinates(markers, {
          edgePadding: {
            bottom: 200,
            right: 50,
            top: 150,
            left: 50,
          },
          animated: true,
        });
      }
    }, 1000);
  };

  return (
    <Box flex="1" alignItems="center" justifyContent="center">
      {markers.length && initialCoords ? (
        <MapView
          style={styles.map}
          initialRegion={initialCoords}
          ref={mapRef}
          onMapReady={fitMarkers}
          showsUserLocation={true}
          loadingEnabled={true}
          // mapType="hybrid"
        >
          {markers.map((marker: any, index: any) => (
            <Marker
              key={index}
              coordinate={marker}
              title={marker.title}
              image={{
                uri: `${_APP_CONFIG._IMAGE_URL}/zemidi/assets/mitra.png`,
              }}
            />
          ))}
        </MapView>
      ) : (
        <LoadingAnimation loading={isLoading} />
      )}
      {/* <Box position="absolute" bottom="20">
        <Box
          bg={colors.primary}
          w="40"
          rounded="full"
          alignItems="center"
          justifyContent="center"
          p="2"
          opacity="0.9"
        >
          <Text fontSize="md" fontWeight="medium" color={colors.white}>
            Load More
          </Text>
        </Box>
      </Box> */}
    </Box>
  );
};

export default MitraMap;
const styles = StyleSheet.create({
  map: {
    width: Dimensions.get("window").width,
    height: Dimensions.get("window").height,
  },
});
